import React from 'react';
import styled from 'styled-components';
import { X } from 'lucide-react';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
  animation: fadeIn 0.3s ease-out;
  backdrop-filter: blur(4px);
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 20px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  
  @keyframes slideUp {
    from { 
      opacity: 0;
      transform: translateY(20px) scale(0.96);
    }
    to { 
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.05);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  color: #4b5563;
  z-index: 10;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
    transform: rotate(90deg);
  }
`;

const Header = styled.div`
  padding: 40px 40px 20px;
  text-align: center;
`;

const Logo = styled.div`
  font-size: 28px;
  font-weight: 800;
  background: linear-gradient(135deg, #3B82F6 0%, #8B5CF6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 10px;
`;

const Subtitle = styled.div`
  color: #6B7280;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const Body = styled.div`
  padding: 0 40px 40px;
`;

const Section = styled.div`
  margin-bottom: 24px;
  line-height: 1.8;
  color: #374151;
  font-size: 16px;
  
  strong {
    color: #111827;
    font-weight: 600;
  }

  p {
    margin-bottom: 16px;
    text-align: justify;
  }
`;

const CompanyInfoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <CloseButton onClick={onClose}>
          <X size={20} />
        </CloseButton>
        
        <Header>
          <Logo>元烁智创</Logo>
          <Subtitle>Technology & Talent Development</Subtitle>
        </Header>

        <Body>
          <Section>
            <p>
              <strong>杭州元烁智创科技有限公司</strong>，坐落于数字经济之城——杭州，是一家专注于<strong>人工智能与人才发展</strong>领域的创新型科技企业。
            </p>
            <p>
              我们深耕于软件开发与大数据分析，致力于将前沿的<strong>AI技术应用于职业成长场景</strong>。公司以“技术赋能人才”为使命，通过自主研发的智能分析算法与互动模型，为用户提供科学、高效的<strong>数字化求职解决方案</strong>。
            </p>
            <p>
              我们希望通过技术手段，打破传统求职过程中的信息壁垒与经验盲区，帮助每一位求职者更精准地认知自我、提升能力，从而在激烈的职场竞争中脱颖而出。杭州元烁智创科技有限公司，不仅是技术的开发者，更是您职业梦想的陪跑者。
            </p>
          </Section>
        </Body>
      </ModalContent>
    </ModalOverlay>
  );
};

export default CompanyInfoModal;
